import { View, Text, Image } from "@react-pdf/renderer";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { UserProfileDto } from "@green0meter/api-client";

import { styles } from "../../PdfDocument.styled";
import PdfDocument from "../../PdfDocument";

interface Header {
  companyName: PdfDocument["companyName"];
  user: UserProfileDto | null;
}

const Header: FC<Header> = ({ companyName, user }) => {
  const { t } = useTranslation();
  const currentDateTime: string = new Date().toLocaleString();

  return (
    <View style={styles.header}>
      <View>
        <Text style={styles.text}>
          {t("csob.pdf.company")}: {companyName || "N/A"}
        </Text>
        <Text style={styles.text}>
          {t("csob.pdf.companyId")}: {user?.activeCompanyId || "N/A"}
        </Text>
        <Text style={styles.text}>
          {t("csob.pdf.createdBy")}: {user?.firstName} {user?.lastName}
        </Text>
        <Text style={styles.text}>
          {t("csob.pdf.date")}: {currentDateTime}
        </Text>
      </View>
      <View>
        <Image style={styles.logo} src="/static/logo-csob.png" />
      </View>
    </View>
  );
};

export default Header;
